{
  "blocks": [
    {
      "id": "med-growth-hormone",
      "kind": "medication",
      "tags": [
        "medications",
        "her",
        "during-cycle",
        "ivf",
        "egg-freezing",
        "evidence-based"
      ],
      "title": "Omnitrope",
      "subtitle": "Somatropin - growth hormone adjunct for ovarian stimulation",
      "body": {
        "genericName": "Somatropin (recombinant human growth hormone)",
        "drugClass": "Growth hormone",
        "purpose": "Used as an adjunct to gonadotropins during IVF stimulation for women with poor ovarian response, diminished ovarian reserve, or prior poor IVF outcomes. Growth hormone may improve follicle recruitment, egg quality, and ovarian response to FSH. It does not directly stimulate the ovaries but appears to sensitize them to gonadotropins.",
        "commonRoutes": ["subcutaneous"],
        "commonForms": ["pen", "vial"],
        "dosageRanges": "1.33-4 mg daily or every other day, starting before or during stimulation (protocol varies by clinic)",
        "howToTake": "Step 1: Prepare - Wash hands thoroughly. Check the pen or vial for expiry date and clarity. Some protocols start growth hormone 6-8 weeks before stimulation (priming); others start it on Day 1 of stimulation - follow your clinic's instructions. | Step 2: Load dose - For the Omnitrope pen, attach a new needle, dial the prescribed dose, and confirm the correct dose appears in the window. For a vial, draw up the prescribed dose with a 27-30 gauge, half-inch syringe. Tap and push out any air bubbles. | Step 3: Clean the site - Swab the lower abdomen or thigh with an alcohol wipe and let air-dry. Alternate injection sites daily. | Step 4: Inject - Pinch the skin, insert the needle at a 90-degree angle, and inject slowly. Hold the needle in place for 10 seconds before withdrawing. Administer typically in the evening. | Step 5: After injection - Apply gentle pressure with gauze - do not rub. Dispose of the needle in a sharps container. | ⚠ Missed dose - Contact your clinic for guidance if you miss a dose. Do not double up the following day without clinic instruction.",
        "sideEffects": [
          "Injection site reactions (redness, swelling)",
          "Mild joint pain or stiffness",
          "Fluid retention and mild swelling",
          "Headache",
          "Carpal tunnel-like symptoms (rare, with prolonged use)",
          "Transient insulin resistance"
        ],
        "storage": "Store unopened in the refrigerator (2-8°C / 36-46°F). Once in use, refrigerate and use within 28 days. Do not freeze.",
        "brandsByCountry": [
          {
            "country": "US",
            "brands": ["Omnitrope", "Saizen", "Norditropin"]
          },
          {
            "country": "UK",
            "brands": ["Omnitrope", "Saizen", "Norditropin"]
          },
          {
            "country": "EU",
            "brands": ["Omnitrope", "Saizen", "Norditropin"]
          },
          {
            "country": "AU",
            "brands": ["Omnitrope", "Saizen", "Norditropin"]
          },
          {
            "country": "FR",
            "brands": ["Omnitrope", "Saizen", "Genotonorm", "Norditropine"],
            "cisByBrand": {
              "Omnitrope": "65086919",
              "Saizen": "66623496",
              "Genotonorm": "64679852",
              "Norditropine": "65953612"
            }
          }
        ],
        "availability": [
          {
            "name": "Omnitrope",
            "manufacturer": "Sandoz",
            "countries": ["EU", "US", "CA", "JP", "GB", "AU"]
          },
          {
            "name": "Genotropin",
            "manufacturer": "Pfizer",
            "countries": ["US", "GB", "EU", "AU", "SG"]
          },
          {
            "name": "Saizen",
            "manufacturer": "Merck Serono",
            "countries": ["US", "GB", "EU", "AU", "SG", "IN"]
          },
          {
            "name": "Norditropin",
            "manufacturer": "Novo Nordisk",
            "countries": ["US", "GB", "EU", "AU", "SG", "IN"]
          },
          {
            "name": "Humatrope",
            "manufacturer": "Eli Lilly",
            "countries": ["US", "GB", "AU"]
          },
          {
            "name": "Nutropin",
            "manufacturer": "Genentech / Ipsen",
            "countries": [
              "US",
              "EU",
              "GB",
              "AT",
              "DK",
              "FI",
              "FR",
              "DE",
              "IE",
              "NL",
              "NO",
              "SE",
              "PT",
              "ES"
            ]
          },
          {
            "name": "Zomacton",
            "manufacturer": "Ferring",
            "countries": ["US", "GB", "IN"]
          },
          {
            "name": "SciTropin A",
            "manufacturer": "Sandoz",
            "countries": ["AU", "SG"]
          },
          {
            "name": "Eutropin",
            "manufacturer": "LG Chem",
            "countries": ["KR", "IN"]
          }
        ],
        "aliases": [
          "Somatropin",
          "Somatropine",
          "Saizen",
          "Norditropin",
          "Hormone de croissance",
          "Growth hormone"
        ],
        "resources": [
          {
            "label": "How to inject Omnitrope (CVS Specialty)",
            "url": "https://www.youtube.com/watch?v=NS0ca3T7wRM",
            "type": "video"
          }
        ],
        "forWhom": "her",
        "frBody": {
          "genericName": "Somatropine (hormone de croissance humaine recombinante)",
          "drugClass": "Hormone de croissance",
          "purpose": "Utilisée en complément des gonadotrophines pendant la stimulation en FIV chez les femmes mauvaises répondeuses, présentant une réserve ovarienne diminuée ou des résultats antérieurs médiocres en FIV. L'hormone de croissance peut améliorer le recrutement folliculaire, la qualité ovocytaire et la réponse ovarienne à la FSH. Elle ne stimule pas directement les ovaires mais semble les sensibiliser aux gonadotrophines.",
          "dosageRanges": "1,33 à 4 mg par jour ou un jour sur deux, débutée avant ou pendant la stimulation (protocole variable selon le centre).",
          "howToTake": "Préparer - Lavez-vous soigneusement les mains. Vérifiez la date de péremption et l'aspect du stylo ou du flacon. Certains protocoles débutent l'hormone de croissance 6 à 8 semaines avant la stimulation (priming) ; d'autres au 1er jour de stimulation - suivez les instructions de votre centre. | Charger la dose - Pour le stylo Omnitrope : fixez une aiguille neuve, sélectionnez la dose prescrite et vérifiez le chiffre affiché. Pour le flacon : prélevez la dose prescrite avec une seringue 27-30 G, 12 mm. Tapotez et chassez les éventuelles bulles d'air. | Désinfecter le site - Désinfectez le bas du ventre ou la cuisse à l'alcool et laissez sécher à l'air. Alternez les sites chaque jour. | Injecter - Pincez la peau, insérez l'aiguille à 90° et injectez lentement. Maintenez l'aiguille en place 10 secondes avant de la retirer. Administrez généralement le soir. | Après l'injection - Appliquez une légère pression avec une compresse - sans frotter. Jetez l'aiguille dans un collecteur. | ⚠ Dose oubliée - Contactez votre centre pour la conduite à tenir en cas d'oubli. Ne doublez pas la dose le lendemain sans avis médical.",
          "sideEffects": [
            "Réactions au point d'injection (rougeur, gonflement)",
            "Douleurs ou raideurs articulaires légères",
            "Rétention d'eau et léger gonflement",
            "Maux de tête",
            "Symptômes de type canal carpien (rare, en cas d'utilisation prolongée)",
            "Insulinorésistance transitoire"
          ],
          "storage": "Conservez non entamé au réfrigérateur (2-8 °C). Une fois entamé, réfrigérez et utilisez dans les 28 jours. Ne pas congeler."
        }
      }
    }
  ],
  "relationships": [],
  "localeVariants": []
}
